<template>
  <v-expansion-panels v-model="panel">
    <v-expansion-panel v-for="(item, i) in sessions" :key="i">
      <v-expansion-panel-header>
        &nbsp;&nbsp;
        <span class="font-weight-medium">
          {{ item.session_num }}
        </span>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-chip class="ma-2 text-center" color="primary" label outlined>
          {{ item.date }}
        </v-chip>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <info-comp
          :topic="item.topic"
          :yt="item.yt_link"
          :zm="item.zoom_link"
          :readings="item.readings"
          :project="item.project"
          :materials="item.materials"
          :req="item.material_req"
          :end_date="item.project_end"
          :statusx="item.status"
          :soln="item.solution"
        ></info-comp>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
      


<script>
import InfoComp from "./InfoContent.vue";
export default {
  components: {
    "info-comp": InfoComp,
  },
  mounted() {
    this.panel = [1];
  },
  beforeCreate() {
    this.panel = [1];
  },
  data: () => ({
    panel: [1],
    sessions: [
      {
        session_num: "ASSESSMENT TEST",
        date: "15 May",
        topic: "ASSESSMENT TEST FOR STUDENTS",
        project:
          "https://docs.google.com/forms/d/e/1FAIpQLSdpBTqB68zn5YHBShCLdFEHYAkSrzLO70kNX84ebYHWGe_l9A/viewform",
        time: "3 PM - 4 PM",
        zoom_link: "",
        yt_link: "https://youtu.be/3Ackvb8KiCg",
        readings:
          "https://docs.google.com/document/d/1tL2dKWsHtqIFTpsYoLm4o-M9zMb7Fl8XT6-5T677jwk/edit",
        status: "done",
        materials: [],
        material_req: "xx",
        project_end: "PRE ASSESSMENT",
        solution: "",
      },
      {
        session_num: "Session 1",
        date: "22 Jan",
        day: "Saturday",
        topic: "Orientation (Students and Teachers)",
        time: "3 PM - 4 PM",
        zoom_link: "",
        yt_link: "https://youtu.be/3Ackvb8KiCg",
        readings:
          "https://docs.google.com/document/d/1tL2dKWsHtqIFTpsYoLm4o-M9zMb7Fl8XT6-5T677jwk/edit",
        project:
          "https://docs.google.com/forms/d/e/1FAIpQLSd2I4ssxWTyXFaa0bPDKQWDvrFQStMyPrJG2KMmEocHZlEc9g/viewform",
        status: "done",
        materials: [],
        material_req: "xx",
        project_end: "PRE ASSESSMENT",
        solution: "",
      },
      {
        session_num: "Session 2",
        date: "1 Feb",
        day: "Tuesday",
        topic: "Kaagaz ke khel - Adventures in A4",
        time: "3 PM - 4 PM",
        zoom_link: "",
        yt_link: "https://youtu.be/cAzAOBXai_s",
        readings:
          "https://docs.google.com/document/d/17zEJcNzer9pHRKhDtKR4HY8uhXCPFg_VdFJU5I_dENU/edit",
        project:
          "https://docs.google.com/forms/d/e/1FAIpQLSfHnP3Wea6HQuuwiSbzZ53iTvyWvWOFJ9EzWBWGn2uGbkaUtQ/viewform",
        status: "done",
        material_req: "yy",
        materials: ["Used A4 paper", "Scissor", "Cutter", "Pen", "Compass"],
        project_end: "ASSIGNMENT - COMPLETE BEFORE Feb 5",
        solution:
          "https://docs.google.com/document/d/1WU3RCi2faN0l3b2Njidh3GI2aBa0HxmKN8EduhVV5lI/edit",
      },
      {
        session_num: "Session 3",
        date: "12 Feb",
        day: "Saturday",
        topic: "Science of Sound",
        time: "3 PM - 4 PM",
        zoom_link: "",
        yt_link: "https://www.youtube.com/watch?v=LHbzLzZpiiw",
        readings: "",
        project:
          "https://docs.google.com/forms/d/e/1FAIpQLSehfM8DHlUPRCXJnPHQs9j8oefz3unWu7ng5gLkMNfxH5xUVw/viewform?usp=sf_link",
        material_req: "yy",
        status: "done",
        materials: [
          "Plastic straw",
          "Scissor",
          "Cutter",
          "Long thick string",
          "Glue",
          " Cello tape",
        ],
        project_end: "ASSIGNMENT - COMPLETE BEFORE FEB 17",
        solution:
          "https://docs.google.com/document/d/1CKIsZmMOPAswKUTsUPxZAFSqPK-0K9Wxxflp5RzisXU/edit?usp=sharing",
      },
      {
        session_num: "Session 4",
        date: "19 Feb",
        day: "Saturday",
        topic: "Maths with Vegetables",
        time: "3 PM - 4 PM",
        zoom_link: "",
        yt_link: "https://youtu.be/ZMWl2TJnepI",
        readings: "",
        project:
          "https://docs.google.com/forms/d/e/1FAIpQLSd1_3WwPrz3YJB-LjgeAvZMhhL6ObqoXmpdWwYafd4Y3LJvpg/viewform?usp=sf_link",
        material_req: "yy",
        status: "done",
        materials: ["Cucumber", "Potato", "Cutter"],
        project_end: "ASSIGNMENT - COMPLETE BEFORE FEB 25",
        solution:
          "https://docs.google.com/document/d/1TTM98XEZJKLd8Sy9_OP8KwkZP_7PjkU452uQiQsH22Y/edit?usp=sharing",
      },
      {
        session_num: "Session 5",
        date: "4 Mar",
        day: "Friday",
        topic: "Computational Thinking",
        time: "3 PM - 4:30 PM",
        zoom_link: "",
        yt_link: "https://youtu.be/GlS-O328aXM",
        readings: "",
        project:
          "https://docs.google.com/forms/d/e/1FAIpQLSfT3gLcrKQ9rNHCLajkstSYKTG_-PqeZb4UipmAVKaYSiNoJg/viewform?usp=sf_link",
        material_req: "yy",
        status: "done",
        materials: ["Pen", "Paper"],
        project_end: "ASSIGNMENT - COMPLETE BEFORE MAR 8",
        solution:
          "https://docs.google.com/document/d/1lMCn8iQbH607WD3Yxb8LXR2ROrlTroF99m7jRzsjlpU/edit?usp=sharing",
      },
      {
        session_num: "Session 6",
        date: "10 Mar",
        day: "Friday",
        topic: "Laws of Motion",
        time: "3 PM - 4:30 PM",
        zoom_link: "",
        yt_link: "https://youtu.be/jA12XfQ1-Mw",
        readings: "",
        project:
          "https://docs.google.com/forms/d/e/1FAIpQLSduBitNFWbMH1-j3yEKfLyfrW1bS3bDWhpATpk2TIeeo3kcmA/viewform?usp=sf_link",
        material_req: "yy",
        status: "done",
        materials: [
          "Plastic bendy straws",
          "Paper straws",
          "Scissors",
          "Balloon",
          "Thread",
          "Cello Tape",
          "Potato",
          "Small Wooden Stick",
        ],
        project_end: "ASSIGNMENT - COMPLETE BEFORE MAR 15",
        solution: "",
      },
      {
        session_num: "Session 7",
        date: "30 Mar",
        day: "Monday",
        topic: "Entertaining Arithmatic and Algebra",
        time: "3 PM - 4:30 PM",
        zoom_link: "",
        yt_link: "https://youtu.be/DA8OpW204X0",
        readings: "https://sparkle-series.web.app/Hands-on-Activities.pdf",
        project:
          "https://docs.google.com/forms/d/e/1FAIpQLSe6Hw47pG4M4e89Oc9GnW6sZz-purSegNWXIyjcAtHqTgb4_w/viewform?usp=sf_link",
        material_req: "yy",
        status: "done",
        materials: ["Pencil colours or Sketch pens", "Blank Paper", "Pen"],
        project_end: "ASSIGNMENT - COMPLETE BEFORE APR 2",
        solution:
          "https://docs.google.com/document/d/1fhHDV3AQV_VDOHtEJysiK01smpI0m254U6Vhi3fPgwk/edit?usp=sharing",
      },
      {
        session_num: "Session 8",
        date: "2 Apr",
        day: "Saturday",
        topic: "Electricity, Magnetism and Electromagnetism",
        time: "3 PM - 4:30 PM",
        zoom_link: "",
        yt_link: "https://youtu.be/5Ved__NXfJo",
        readings: "",
        project:
          "https://docs.google.com/forms/d/e/1FAIpQLSd6I6_JFldvvVEisWhdmA8C9XGTlTvf-dHTCDj4bc6qSfHEEA/viewform?usp=sf_link",
        material_req: "yy",
        status: "done",
        materials: ["Pen", "Paper"],
        project_end: "ASSIGNMENT - COMPLETE BEFORE APR 6",
        solution: "",
      },
      {
        session_num: "Session 9",
        date: "7 Apr",
        day: "Thursday",
        topic: "Concluding session",
        time: "3 PM - 4:30 PM",
        zoom_link: "",
        yt_link: "https://youtu.be/LZcLYLQhShk",
        readings: "",
        project: "",
        material_req: "yy",
        status: "done",
        materials: ["Newspapers"],
        project_end: "",
        solution: "",
      },
    ],
  }),
};
</script>

<style>
</style>